import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "./locales/en/common.json";
import hiCommon from "./locales/hi/common.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true, // 🔥 THIS LINE (IMPORTANT)
    },

    resources: {
      en: {
        common: enCommon,
      },
      hi: {
        common: hiCommon,
      },
    },

    defaultNS: "common",
  });

export default i18n;
